import { logError } from '../error';
const getMessageBus = () => {
    try {
        return window.WH.messageBus;
    }
    catch (error) {
        logError({ error });
        return { publish: null, subscribe: null, unsubscribe: null };
    }
};
export const { publish, subscribe, unsubscribe } = getMessageBus();
